<script>
export default {
  data() {
    return {
      message: null,
    }
  },
  methods: {
    setErrorMessage(error) {
      if (error.errors && error.errors.length && error.errors[0] !== null) {
        this.danger(error.errors[0])
      } else if (typeof error === 'string') {
        this.danger(error)
      } else {
        this.danger(error.message)
      }
    },
    setMessage({ theme = 'neutral', text = '' } = {}) {
      this.message = { theme, text }
    },
    clearMessage() {
      this.message = null
    },
    success(text) {
      this.setMessage({ theme: 'success', text })
    },
    warning(text) {
      this.setMessage({ theme: 'warning', text })
    },
    danger(text) {
      this.setMessage({ theme: 'danger', text })
    },
  },
}
</script>
